// Shared table-rendering geometry, used by both the owner's drag-and-drop designer
// (TablesTab) and the public static "my table" map, so seat numbering/positioning
// stays visually identical between the two.
export function tokenSize(shape) {
  return shape === "rect" ? { w: 176, h: 104 } : { w: 118, h: 118 };
}

// The dots themselves sit at a fixed ring of points around the table --
// `rotationDeg` doesn't move them. Instead it shifts WHICH seat (and its
// name/number) lands on which fixed dot, by an integer number of steps
// (nearest seat position for the given angle). This keeps the ring visually
// stationary while dragging the rotation dial -- only the numbering/guest
// assigned to each dot advances around it, still moving together since each
// dot always shows one consistent (number, name) pair.
export function seatLabelPositions(size, capacity, rotationDeg = 0, ccw = false) {
  const cx = size.w / 2;
  const cy = size.h / 2;
  const radius = (size.w / 2 + size.h / 2) / 2 + 34;
  const dir = ccw ? -1 : 1;
  const basePoints = Array.from({ length: capacity }, (_, k) => {
    const angle = dir * ((2 * Math.PI * k) / capacity) - Math.PI / 2;
    return { left: cx + radius * Math.cos(angle), top: cy + radius * Math.sin(angle) };
  });
  const steps = Math.round((rotationDeg / 360) * capacity);
  const offset = ((steps % capacity) + capacity) % capacity;
  return Array.from({ length: capacity }, (_, i) => basePoints[(i + offset) % capacity]);
}
